import React from 'react'
import DonationForm from './DonationForm'
import Header from '../Common/Navbar'
import Banner from '../Common/Banner'
import { Footer } from '../Footer/Footer'

export const DonationPage = () => {
  return (
    // <AuthWrapper>
    <div>
        <Header/>
        <Banner title={'Donations'} text={`In these hard times of poverty, unemployment, low wages amid escalating rate of inflation, the poor people are suffering the most. They find it most difficult to earn enough to feed their kith and kin and provide them with clothing and education. To offer solace and relief to the poor.`}/>
        <DonationForm/>
        <Footer/>
    </div>
    // </AuthWrapper>
  )
}
